<template>
  <div class="d-flex flex-column gap-3 mt-3 pt-3" :aria-label="t('accessibility.aria.label.ballot')">
    <h5 class="mb-3 summary-ballot-title">{{ title }}</h5>
    <div
      v-for="(selectionPile, pileIndex) in contestSelection.piles"
      :key="JSON.stringify(selectionPile)"
      class="d-flex flex-column"
    >
      <AVPileSummary
        :contest="formattedContest"
        :selection-pile="selectionPile"
        :pile-index="pileIndex"
        :total-piles="contestSelection.piles.length"
        active-state="summary"
        :locale="locale"
        :is-prefilled="isBallotPrefilled"
        @edit-current-selection="emits('gotoSelection', formattedContest.reference)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { formatContest } from "@/entrypoints/shared/contest_utilities";
import { usePresentationStore } from "@/entrypoints/stores/presentation";
import type { PropType, ContestSelection, ConferenceContest } from "@/types";

const { t, locale } = useI18n();

const presentationStore = usePresentationStore();

const props = defineProps({
  contestSelection: {
    type: Object as PropType<ContestSelection>,
    required: true,
  },
  isBallotPrefilled: {
    type: Boolean,
    default: false,
  }
});

const emits = defineEmits(["gotoSelection"]);

const formattedContest = computed(() =>
  formatContest(presentationStore.contests.find((contest: ConferenceContest) =>
    contest.reference === props.contestSelection.reference)
));

const title = computed(() =>
  formattedContest.value.title ? formattedContest.value.title[locale.value] : "");
</script>

<style>
.summary-ballot-title {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: 2rem;
  color: rgb(17, 24, 39);
  font-weight: 500;
}
</style>
